<template>
  <sdz-modal
    ref="sdzModal"
    @close="close"
    :title="modalTitle"
    width="650"
    hide-confirm-button
    hide-cancel-button
    persistent
    custom-class="sheet-modal"
    close-icon
  >
    <template>
      <div
        class="sheet-modal-content"
      >
        <p>
          Selecione a planilha padrão correspondente a campanha.
        </p>
        <div
          :style="getMainStyle"
          class="main"
        >
          <div
            v-for="(option, index) in sheetOptions"
            :key="index"
            @click="downloadSheet(option)"
            :class="activeClassByCampaign === option.title ? 'active' : ''"
            class="list-item"
          >
            <div>
              <img
                :src="require(`@/assets/images/icons/sheet.svg`)"
                width="50"
              >
              <span>Planilha padrão - {{ option.title }}</span>
            </div>
            <img
              :src="require(`@/assets/images/icons/downloadSheet.svg`)"
              width="20"
            >
          </div>
        </div>
      </div>
    </template>
  </sdz-modal>
</template>

<script>
  import sellOutService from '@/services/containers/app/sell-out'
  const fileDownload = require('js-file-download')

  export default {
    name: 'DefaultSpreadsheetModal',

    components: {
      SdzModal: () => import('@/components/sdz/SdzModal.vue'),
    },

    props: {
      campaigns: {
        type: Array,
        default: () => []
      }
    },

    data: () => ({
      activeClassByCampaign: ''
    }),

    computed: {
      modalTitle() {
        return 'Baixar planilha padrão'
      },
      sheetOptions() {
        const campaigns = this.campaigns
          .filter(({ status, mainCampaign }) => {
            const parent = this.campaigns.find(campaign => campaign._id === mainCampaign)
            const parentIsActive = !mainCampaign ? true : parent?.status === 'active'
            return parentIsActive && status === 'active'
          })
        return campaigns.map(({ _id, name, mainCampaign, hasApportionments }) => ({ title: name, value: { _id, name, parent: mainCampaign, hasApportionments }}))
      },
      getMainStyle() {
        if (this.sheetOptions.length < 4) return
        return {
          overflowY: 'scroll'
        }
      }
    },

    methods: {
      open() {
        this.$refs.sdzModal.show = true
      },
      close() {
        this.$refs.sdzModal.show = false
      },
      async downloadSheet({ value }) {
        this.activeClassByCampaign = value.name
        this.$showLoading()
        try {
          const { data } = await sellOutService.getSelloutDefaultSpreadsheetById(value?._id)
          fileDownload(
            data,
            'planilha-padrao.xlsx'
          )
        } catch (err) {
          this.$toast(err.response?.data?.message, 'red')
        } finally {
          this.$hideLoading()
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .sheet-modal {
    &-content {
      padding: 15px;
      p {
        font-size: 14px;
        color: var(--neutral-high-lightest);
        font-weight: 400;
      }
      .main {
        max-height: 275px;
        .list {
          &-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px;
            border: 1px var(--neutral-low-medium) solid;
            border-radius: 5px;
            margin-bottom: 10px;
            cursor: pointer;
            div {
              display: flex;
              align-items: center;
              span {
                margin-left: 10px;
                font-size: 14px;
                font-weight: 500;
              }
            }
            transition: background-color 0.8s ease-out;
            &:hover {
              background-color: var(--background-medium);
              transition: background-color 0.8s ease-out;
            }
          }
        }
        .active {
          border: 1px var(--primary-medium) solid;
        }
      }
    }
  }
</style>
